export const categories = [
  "Actors",
  "Adventurers",
  "Artists",
  "Business",
  "Criminals",
  "Directors",
  "Engineers",
  "Fictional characters",
  "Historical personalities",
  "Inventors",
  "Models",
  "Musicians",
  "Mythical",
  "Philosophers",
  "Politicians",
  "Producers",
  "Public figures",
  "Scientists",
  "Scriptwriters",
  "Show-business",
  "Social Activists",
  "Sport",
  "Stand-up comedy",
  "Travelers",
  "War leaders",
  "Writers",
  "Special",
];

export const sexOptions = ["MALE", "FEMALE", "TRANSITIONED"] as const;

export const ethnicityOptions = [
  "WHITE",
  "BLACK",
  "ASIAN",
  "HISPANIC",
  "MIDDLE EAST",
] as const;
